import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultCardComponent } from './result-card/result-card.component';



@NgModule({
  declarations: [ResultCardComponent],
  exports: [ResultCardComponent],
  imports: [
    CommonModule
  ]
})
export class SharedComponentsModule { }
